
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';

import { getStorage } from 'firebase/storage';
// import { getFunctions } from 'firebase/functions'; // Removed due to import error
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBLpi5VDALHJfJO3iuHaxVL1kuDLnB0o0s",
  authDomain: "janoobi-studio.firebaseapp.com",
  projectId: "janoobi-studio",
  storageBucket: "janoobi-studio.firebasestorage.app",
  messagingSenderId: "636464369155",
  appId: "1:636464369155:web:a3129fe2bba57bd3a34836"
};

let app;

// Initialize Firebase only if it hasn't been initialized yet
if (!firebase.apps.length) {
    app = firebase.initializeApp(firebaseConfig);
    
    // Initialize Firestore with modern persistence settings (Multi-tab support)
    // This replaces the deprecated enablePersistence() / settings() methods
    try {
        initializeFirestore(app, {
            localCache: persistentLocalCache({
                tabManager: persistentMultipleTabManager()
            }),
            ignoreUndefinedProperties: true
        });
    } catch (e) {
        // If already initialized, ignore
        console.log("Firestore persistence already initialized");
    }

} else {
    app = firebase.app();
}

// Export Auth as compat instance
export const auth = firebase.auth();

// Initialize Firestore as compat instance (It uses the underlying instance configured above)
export const db = firebase.firestore();

export const storage = getStorage(app as any);
export const functions = firebase.functions();

export default app;
